import { Component, OnInit,Input } from '@angular/core';
import { Constants } from '../../../shared/models/constants';

@Component({
  selector: 'app-storeBookDetails',
  templateUrl: './storeBookDetails.component.html',
  styleUrls: ['./storeBookDetails.component.css']
})
export class StoreBookDetailsComponent implements OnInit {
  @Input() data: any;
  bookFooterIcon = ["icon-Rename", "icon-Share","icon-Imports","icon-Communication", "icon-Annotation"];
  bookDetails;
  selectedTab = 0;
  constructor() { }

  ngOnInit() {
    // this.bookDetails = this.data.popupProps.curComp.selBookDetails;
    this.bookDetails  = this.data;
  }

}



// WEBPACK FOOTER //
// ./src/app/store/popups/storeBookDetails/storeBookDetails.component.ts